/** All standard modal dimensions belong here, never in feature components. */
export const appDialogConfig = {
  simpleForm: { width: "max-w-md" },
  gridForm: { width: "max-w-2xl" },
  generic: { width: "max-w-xl" },
  information: { width: "max-w-lg" },
  alert: { width: "max-w-lg" },
  destroy: { width: "max-w-lg" },
  fullscreen: { width: "max-w-none" },
  narrow: { width: "max-w-lg" },
  custom: { width: "" },
} as const

export function appDialogClasses(variant: AppDialogVariant): string {
  if (variant === "custom") return ""
  return [
    appDialogStyles.viewport,
    appDialogConfig[variant].width,
    variant === "alert" || variant === "destroy"
      ? appDialogStyles.confirmationShell
      : "flex min-h-0 flex-col gap-0 overflow-clip p-0",
    variant === "fullscreen" ? appDialogStyles.fullscreen : "",
  ]
    .filter(Boolean)
    .join(" ")
}

export type AppDialogVariant = keyof typeof appDialogConfig
export const appDialogStyles = {
  body: "min-h-0 flex-1 overflow-y-auto p-4 space-y-2",
  footer: "bg-tinted text-tinted-foreground flex shrink-0 flex-wrap items-center justify-end gap-2 border-t p-3",
  header: "flex min-h-10 shrink-0 items-center gap-2 border-b py-1 pl-4 pr-2",
  logoHeader: "min-h-16",
  wizardHeader: "flex min-h-16 shrink-0 items-center gap-3 border-b py-2 pr-2 pl-4",
  wizardFooter:
    "bg-tinted text-tinted-foreground flex shrink-0 flex-wrap items-center justify-between gap-2 border-t p-3",
  confirmationShell: "flex min-h-0 flex-col gap-4 overflow-hidden p-6",
  confirmationHeader: "flex shrink-0 items-start gap-2 text-center sm:text-left",
  confirmationBody: "-mt-2 min-h-0 overflow-y-auto space-y-2",
  confirmationFooter: "flex shrink-0 flex-col-reverse gap-2 sm:flex-row sm:justify-end",
  viewport: "w-[calc(100vw-2rem)] max-h-[calc(100dvh-8rem)]",
  dashboardComponent:
    "top-1/2 flex h-[44rem] max-h-[calc(100dvh-4rem)] w-[calc(100vw-2rem)] max-w-5xl -translate-y-1/2 flex-col gap-0 overflow-hidden p-0",
  fullscreen:
    "inset-4! top-4! left-4! h-[calc(100dvh-2rem)]! w-[calc(100vw-2rem)]! max-h-none! max-w-none! translate-x-0! translate-y-0!",
} as const
